import tmhRequest from '@/config/tmhRequest'

export default {
  searchCustomerNursingInfo: function (data) {
    return tmhRequest({
      url: '/customer/tmh/customernursinginfo/searchcustomernursinginfo',
      method: 'post',
      params: data,
    })
  },

  searchListCustomerNursingInfo: function (data) {
    return tmhRequest({
      url: '/customer/tmh/customernursinginfo/searchlistcustomernursinginfo',
      method: 'post',
      params: data,
    })
  },

}


// WEBPACK FOOTER //
// ./src/api/tmh/customer/customernursinginfo.js